import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpErrorResponse } from '@angular/common/http';
import { LoginService } from '../login/login.service';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from '../registration/registration.service';
declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  username: any;
  yearName: any;
  @ViewChild('changePasswordForm') changePasswordForm: NgForm;
  responseData: any;
  oldPassword: any = '';
  newPassword: any = '';
  yearlist:any;
  data:any;
  YearID:any;
  dropDownData:any;
  

  constructor(private service: LoginService, private toastr: ToastrService, private spinner: NgxSpinnerService, private router: Router,private yearService:RegistrationService) { }

  ngOnInit(): void {
    this.username = localStorage.getItem("userName");
    this.yearName = localStorage.getItem("yearName");
    this.fillYear();
    this.YearID = localStorage.getItem("yearID");
  
  }
  Logout() {
    if (localStorage.getItem("cd") == ")(*&") {
      //this.fillAdminMenu();
      this.spinner.show();
      localStorage.clear();
      //setTimeout(() => {
      this.spinner.hide();
      this.router.navigate(["/aciadmin"]);
    }
    if (localStorage.getItem("cd") == "$#@!") {
      //this.fillUserMenu();
      this.spinner.show();
      localStorage.clear();
      //setTimeout(() => {
      this.spinner.hide();
      this.router.navigate(["/collegelogin"]);
    }
    //}, 1000);
  }

  ChangePassword() {
    $("#resetpassword").modal('show');
    this.changePasswordForm.resetForm();
  }

  Close() {
    this.oldPassword = '';
    this.newPassword = '';
    $("#resetpassword").modal('hide');
  }

  fillYear() {
    const data = {
    };
    this.yearService.fillYear(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.yearlist = this.dropDownData.dropdownlist;
        //this.data.YearID = Number(localStorage.getItem("YearID"));
        //this.data.YearID = Number(localStorage.getItem("YearID"));
      });
  }


  ChangeYearDetails()
  {
    localStorage.setItem("YearID", this.YearID);
    console.log(localStorage.getItem("YearID"));
  }
  onSubmit() {
    if (this.changePasswordForm.valid) {

      if (this.changePasswordForm.value['oldPassword'] == this.changePasswordForm.value['newPassword']) {
        this.toastr.error("Old Password must be different to New Password");
        return;
      }

      if (this.changePasswordForm.value['confirmPassword'] != this.changePasswordForm.value['newPassword']) {
        this.toastr.error("Password and Confirm Password does not match");
        return;
      }

      this.spinner.show();

      const data = {
        oldPassword: this.changePasswordForm.value['oldPassword'],
        newPassword: this.changePasswordForm.value['newPassword']
      }

      this.service.changePassword(data)
        .subscribe(data => {
          this.responseData = data;

          this.spinner.hide();

          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
          }
          else {
            this.toastr.success(this.responseData.message);
            $("#resetpassword").modal('hide');
            this.changePasswordForm.resetForm();
            this.router.navigate(["/login"]);
          }
        },
          (err: HttpErrorResponse) => {
            localStorage.clear();
            this.spinner.hide();
            this.toastr.error('Something Went Wrong');
            this.router.navigate(['/']);
          });
    }
  }
}
